import { Box, Switch, ViewListIcon, ViewTilesIcon } from "@saleor/macaw-ui-next";
import React from "react";

import { ProductListViewType } from "../ProductListPage";

interface ProductListViewSwitchProps {
  defaultValue: ProductListViewType;
  setProductListViewType: (value: ProductListViewType) => void;
}

const TableViewIcon = () => (
  <Box display="flex" alignItems="center" justifyContent="center">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
      <path d="M3 3h14a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v2h5V5H4zm7 0v2h5V5h-5zM4 9v2h5V9H4zm7 0v2h5V9h-5zM4 13v2h5v-2H4zm7 0v2h5v-2h-5z"/>
    </svg>
  </Box>
);

export const ProductListViewSwitch = ({
  defaultValue,
  setProductListViewType,
}: ProductListViewSwitchProps) => (
  <Switch
    defaultValue={defaultValue}
    onValueChange={value => {
      setProductListViewType(value as ProductListViewType);
    }}
  >
    <Switch.Item id="datagrid" value="datagrid" data-test-id="datagrid-view-button">
      <TableViewIcon />
    </Switch.Item>
    <Switch.Item id="tile" value="tile" data-test-id="tile-view-button">
      <ViewTilesIcon size="medium" />
    </Switch.Item>
    <Switch.Item id="list" value="list" data-test-id="list-view-button">
      <ViewListIcon size="medium" />
    </Switch.Item>
  </Switch>
);
